module.exports = __webpack_public_path__ + "static/media/nissan-checkmark.7429277a.svg";